import { createVuetify } from 'vuetify';
import 'vuetify/styles'; // 引入 Vuetify 樣式
import { aliases, mdi } from 'vuetify/iconsets/mdi'

export default createVuetify({
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi, 
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#000000',
          secondary: '#FFFFFF',
        },
      },
    },
  },
});